import { IMG_LOGO_DEFAULT, IMG_LOGO_LINEAL_DEFAULT } from '../../constants';
import { AssetAddiLogoSvgUrl } from '@addi/ds-legacy/util-tokens/pkg';

export const BadgeSrc = (
  allySlug: string,
  iconType: string
): { [key: string]: string | undefined } => ({
  background: `url('${allyLogo(
    allySlug,
    iconType
  )}') no-repeat center, transparent`,
  backgroundSize: 'contain',
});

export const AddiLogoSrc = (allySlug: string) => {
  switch (allySlug) {
    default:
      return AssetAddiLogoSvgUrl;
  }
};

const allyLogo = (allySlug: string, iconType: string) => {
  switch (allySlug) {
    default:
      return iconType === 'lineal' ? IMG_LOGO_LINEAL_DEFAULT : IMG_LOGO_DEFAULT;
  }
};
